<template>
  <div class="report-filters">
    <div v-for="field in selectFields" :key="field.key" class="report-filter">
      <label>{{ field.label }}</label>
      <el-select
        :value="value[field.key]"
        :multiple="field.multiple"
        :placeholder="field.placeholder"
        clearable
        collapse-tags
        filterable
        @change="updateField(field.key, $event)"
      >
        <el-option
          v-for="option in field.options"
          :key="option.id"
          :label="option.name"
          :value="option.id"
        />
      </el-select>
    </div>

    <div class="report-filter">
      <label>Ngày thi</label>
      <el-date-picker
        :value="value.exam_date"
        type="daterange"
        range-separator="-"
        start-placeholder="Từ ngày"
        end-placeholder="Đến ngày"
        format="dd/MM/yyyy"
        value-format="yyyy-MM-dd"
        clearable
        @input="updateField('exam_date', $event)"
      />
    </div>

    <div class="report-filter">
      <label>Bộ phận</label>
      <el-select
        :value="value.department_id"
        placeholder="Chọn bộ phận"
        clearable
        filterable
        @change="updateField('department_id', $event)"
      >
        <el-option
          v-for="department in options.departments"
          :key="department.id"
          :label="department.name"
          :value="department.id"
        />
      </el-select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReportFilters',
  props: {
    value: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      required: true
    }
  },
  computed: {
    selectFields() {
      return [
        {key: 'center_id', label: 'Trung tâm', placeholder: 'Chọn trung tâm', options: this.options.centers},
        {key: 'branch_ids', label: 'Chi nhánh', placeholder: 'Chọn chi nhánh', options: this.options.branches, multiple: true},
        {key: 'area_ids', label: 'Khu vực', placeholder: 'Chọn khu vực', options: this.options.areas, multiple: true},
        {key: 'exam_type_ids', label: 'Loại thi', placeholder: 'Chọn loại bài thi', options: this.options.exam_types, multiple: true},
        {key: 'exam_form', label: 'Hình thức thi', placeholder: 'Chọn hình thức thi', options: this.options.exam_forms}
      ];
    }
  },
  methods: {
    updateField(key, value) {
      this.$emit('input', {...this.value, [key]: value});
      this.$emit('change', key);
    }
  }
};
</script>

<style scoped lang="scss" src="./ReportFilters.scss"></style>
